import { useEffect } from "react";
import { logPageView } from "src/utils/analytics";
import { useDealer } from "./useDealer";

const capitalizeFirstLetters = (title: string) =>
  title
    .split(" ")
    .map((word: string) => word[0].toUpperCase() + word.slice(1))
    .join(" ");

export const usePageView = (pageTitle: string) => {
  const { dealer_id } = useDealer();

  useEffect(() => {
    document.title = `${capitalizeFirstLetters(pageTitle)} - PorchPass`;
    logPageView(dealer_id);
  }, []);
};
